import React, { useState } from 'react';
import styles from './ApiSecretKey.module.scss';
import CredentialCard from './CredentialCard';

const ApiSecretKey = ({ profileData }) => {
    const [isCopied, setIsCopied] = useState(false);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-CA'); // Formats to YYYY-MM-DD
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        });
    };

    return (
        <div className={styles.credentialsContainer}>
            <CredentialCard
                label="Client ID"
                value={profileData.clientID || 'N/A'}
                onCopy={handleCopy}
                isCopied={isCopied}
            />
            <CredentialCard
                label="Active Secret Key"
                value={profileData.maskedSecret || 'N/A'}
                status="Active"
                viewSecretKeyLink={profileData.viewSecretKeyLink}
            />
            <CredentialCard
                label="Generated On"
                value={formatDate(profileData.secreteKeyGeneratedOn)}
            />
            <CredentialCard
                label="Expires On"
                value={formatDate(profileData.expiresOn)}
            />
        </div>
    );
};

export default ApiSecretKey;